import { render, staticRenderFns } from "./RemMatHandle.vue?vue&type=template&id=636baf18&scoped=true"
import script from "./RemMatHandle.vue?vue&type=script&lang=js"
export * from "./RemMatHandle.vue?vue&type=script&lang=js"
import style0 from "./RemMatHandle.vue?vue&type=style&index=0&id=636baf18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636baf18",
  null
  
)

export default component.exports